/* eslint-disable no-param-reassign */
import {
  Swiper,
  Pagination,
  EffectFade,
  Autoplay,
} from 'swiper';

const initHeroCarousel = () => {
  const carousels = document.querySelectorAll('.hero-carousel__swiper');

  carousels.forEach((carousel) => {
    const slides = carousel.querySelectorAll('.swiper-slide');
    const slidesCount = slides.length;

    if (slidesCount <= 1) return;

    const paginationEl = carousel.parentElement.querySelector('.hero-carousel__pagination');
    if (!paginationEl) return;

    const swiper = new Swiper(carousel, {
      modules: [Pagination, EffectFade, Autoplay],
      loop: false,
      rewind: true,
      grabCursor: true,
      allowTouchMove: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1000,
      pagination: {
        el: paginationEl,
        clickable: true,
        type: 'bullets',
        bulletClass: 'hero-carousel__pagination-bullet',
        bulletActiveClass: 'hero-carousel__pagination-bullet--active',
        renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`,
      },
      on: {
        // eslint-disable-next-line no-shadow
        click: (swiper, event) => {
          if (!event.target.closest('button, a')) {
            swiper.slideNext();
          }
        },
        // eslint-disable-next-line no-shadow
        slideChange: (swiper) => {
          const prevSlide = swiper.slides[swiper.previousIndex];
          prevSlide.querySelector('video')?.mediaControl?.pause();

          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector('video')?.mediaControl?.playIfAble();
        },
      },
    });

    const getBullets = () => Array.from(paginationEl.querySelectorAll('.hero-carousel__pagination-bullet'));

    const getActiveSlideButton = () => carousel.querySelector('.swiper-slide-active .hero-carousel__content-link');

    const slideButtons = Array.from(
      carousel.querySelectorAll('.hero-carousel__content-link'),
    );

    const updateSlideButtonsTabIndex = () => {
      const activeBtn = getActiveSlideButton();

      slideButtons.forEach((btn) => {
        if (btn === activeBtn) {
          btn.tabIndex = 0;
          btn.removeAttribute('aria-hidden');
        } else {
          btn.tabIndex = -1;
          btn.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const preventHiddenCTAClick = (event) => {
      const activeBtn = getActiveSlideButton();
      if (!activeBtn) return;

      const clickedBtn = event.target.closest('.hero-carousel__content-link');
      if (!clickedBtn) return;

      if (clickedBtn !== activeBtn) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    carousel.addEventListener('click', preventHiddenCTAClick, true);

    swiper.on('init', () => {
      updateSlideButtonsTabIndex();
    });

    swiper.on('slideChange', () => {
      updateSlideButtonsTabIndex();
    });

    swiper.init?.();

    const attachBulletFocusLogic = () => {
      const bullets = getBullets();

      bullets.forEach((bullet) => {
        // eslint-disable-next-line no-param-reassign
        bullet.tabIndex = 0;

        bullet.addEventListener('click', () => {
          setTimeout(() => {
            const activeBtn = getActiveSlideButton();
            if (activeBtn) activeBtn.focus();
          }, 0);
        });

        bullet.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            setTimeout(() => {
              const activeBtn = getActiveSlideButton();
              if (activeBtn) activeBtn.focus();
            }, 0);
          }
        });
      });
    };

    attachBulletFocusLogic();

    paginationEl.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !event.shiftKey) return;

      const bullets = getBullets();
      const firstBullet = bullets[0];

      if (event.target === firstBullet) {
        const activeBtn = getActiveSlideButton();
        if (activeBtn) {
          event.preventDefault();
          activeBtn.tabIndex = 0;
          activeBtn.removeAttribute('aria-hidden');
          activeBtn.focus();
        }
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-hero-carousel', () => {
      initHeroCarousel();
    });
  } else {
    initHeroCarousel();
  }
});
